/* eslint-disable */
import React from 'react';

/**
 * @export
 * @type {React.Context<Accounts>}
 */
const AccountsContext = React.createContext();

export default AccountsContext;
